module.exports = __webpack_public_path__ + "static/img/65.6dd63d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/65.png
// module id = w/IJ
// module chunks = 0